import { ElButton,ElColorPicker,ElDropdown,ElDropdownItem,ElDropdownMenu,ElForm,ElFormItem,ElInput,ElInputNumber,ElOption,ElSelect } from 'element-plus'

export const components = [
    ElButton,
    ElColorPicker,
    ElDropdown,
    ElDropdownItem,
    ElDropdownMenu,
    ElForm,
    ElFormItem,
    ElInput,
    ElInputNumber,
    ElOption,
    ElSelect
]
